<template>
	<div class="Authority">
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div style="margin-right: 20px;">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="select" @reset="reset">
				</CommonBtngroup>
			</div>
		</div>
		<div class="BottomTable">
			<div style="display: flex;">
				<div style="" v-if="qx.add">
					<Commonbtn backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add"
						:src="require('@/assets/icon/icon-update.png')">
					</Commonbtn>
				</div>
				<div style="" v-if="qx.update">
					<Commonbtn backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="update"
						:src="require('@/assets/icon/icon-update.png')">
					</Commonbtn>
				</div>
				<div style="" v-if="qx.del">
					<Commonbtn backgroundColor="#F9FAFC" title="删除" fontSize="14px" @btnclick="AuthorityDel"
						:src="require('@/assets/icon/icon-del.png')">
					</Commonbtn>
				</div>
				<div style="" v-if="qx.add">
					<CommonbtnUpLoad types="files" backgroundColor="#F9FAFC" title="导入" fontSize="14px"
						@getFiles="SealUpload" :src="require('@/assets/channel/zhengzhao.png')">
					</CommonbtnUpLoad>
				</div>
				<div style="">
					<Commonbtn backgroundColor="#F9FAFC" title="导出" fontSize="14px" @btnclick="ExportAuthoriy"
						:src="require('@/assets/channel/export.png')">
					</Commonbtn>
				</div>
				<div style="">
					<a class="Dowload" style="text-decoration: underline;margin-top: 15px;"
						@click="DownloadTemplate">下载导入模版</a>
				</div>
			</div>
			<div class="Table">
				<Commontable ref="refTableCenter" @handleSelectionChange="handleSelectionChange"
					@onRowClick="onRowClick" width="1000px" colnum=511 :tableData="tableData" :headerData="headerData"
					height="100%">
				</Commontable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' :pageSize="pageSize"
						@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
					</Pagination>
				</div>
			</div>
		</div>
		<DialogFrom width="1000px" :title="`${currData?'编辑':'新增'}授权关系`" :OKASCAN="true"
			:dialogVisible="dialogVisibAuthorizationsAPP" @cancel="dialogVisibAuthorizationsAPP = false"
			@dialogOK="dialogOKAuthorizationsAPP">
			<FromComm :FromArr="FromArrEditor" @remoteMethod="remoteMethod" @invClassChange="invClassChange"></FromComm>
		</DialogFrom>

		<DialogFrom width="1000px" title="删除原因" :OKASCAN="true" :dialogVisible="dialogVisibdelReason"
			@cancel="canceldelReason" @dialogOK="dialogOKdelReason">
			<el-input type="textarea" placeholder="请输入删除原因" v-model="RejectReasondel">
			</el-input>
		</DialogFrom>
		<DialogFrom width="1000px" title="驳回原因" :OKASCAN="true" :dialogVisible="dialogVisibRejectReason"
			@cancel="cancelRejectReason" @dialogOK="dialogOKRejectReason">
			<el-input type="textarea" placeholder="请输入驳回原因" v-model="RejectReason">
			</el-input>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg"
			@cancel="dialogVisiblesdrjg = false" @dialogOK="dialogVisiblesdrjg = false">
			<div class="from">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleVerify" @cancel="cancelVerify"
			@dialogOK="dialogOKVerify" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审核通过这条信息吗？</span>
		</Dialog>

		<!--删除提示框-->
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="dialogVisibleDel = false"
			@dialogOK="dialogOKDel" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleInv" @cancel="cancelInv" @dialogOK="dialogOKInv"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要作废这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleCancelSeal" @cancel="cancelCancelSeal"
			@dialogOK="dialogOKCancelSeal" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要取消这条信息的盖章吗？</span>
		</Dialog>
	</div>
</template>

<script>
	import FromComm from '../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../components/common-btn.vue'
	import CommonbtnUpLoad from './../../../../../../components/common-upload.vue'
	import Commontable from '../../../../../../components/common-table.vue'
	import Pagination from '../../../../../../components/pagination.vue'
	import DialogFrom from '../../../../../../components/dialog-from.vue'
	import Dialog from '../../../../../../components/dialog.vue'
	import CertificateAuthorizationGCTQ from './components/CertificateAuthorizationGCTQ'
	import CertificateAuthorizationGCYL from './components/CertificateAuthorizationGCYL'
	import commFromVuePdf from '@/components/comm-from-vuePdf.vue'
	import FromArr from './FromData/FromArr'
	import FromArrEditor from './FromData/FromArrEditor'
	import FromArrHP from './FromData/FromArrHP'
	import headerData from './headerData/headerData'
	import headerDataEditor from './headerData/headerDataEditor'
	import headerDataEditorHP from './headerData/headerDataEditorHP'
	import utils from '../../../../../../common/utils'
	import {
		BusinessAuthorityList,
		BusinessAuthorityInfo,
		BusinessAuthorityDownloadTemplet,
		BusinessAuthorityGeneratePdf,
		BusinessAuthorityGeneratePdfList,
		BusinessAuthorityPrintPdfList,
		BusinessAuthorityDisable,
		APPBusinessAuthorityAdd,
		BusinessAuthorityReject,
		BusinessAuthorityRemoveAttachment,
	} from '@/api/channel'
	import {
		HospitalList,
		CustomerList,
		GetHospitalType,
		InventoryClassList,
		UserInfoByInvClass
	} from '@/api/home'

	import {
		CusRelationAuthorityList,
		TempletCusRelationAuthority,
		ImportCusRelationAuthority,
		ExportCusRelationAuthority,
		DeleteCusRelationAuthority,
		AddCusRelationAuthority,
		EditCusRelationAuthority,
		InfoCusRelationAuthority
	} from '@/api/newsapi'

	import {
		__esModule
	} from 'less/lib/less/default-options'
	export default {
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Commontable,
			Pagination,
			DialogFrom,
			CommonbtnUpLoad,
			CertificateAuthorizationGCTQ,
			CertificateAuthorizationGCYL,
			Dialog,
			commFromVuePdf
		},
		props: {},
		data() {
			return {
				dialogVisibleCancelSeal: false,
				dialogVisibdelReason: false,
				dialogVisibRejectReason: false,
				dialogVisiblesdrjg: false,
				dialogVisibleVerify: false,
				GCTQORGCYL: false,
				dialogVisibleDel: false,
				dialogVisibleInv: false,
				dialogVisibAuthorizationsAPP: false,
				fileUrl: '',
				RejectReason: '',
				RejectReasondel: '',
				InvClass: '',
				invClassRow: '',
				title: '',
				BAMID: '',
				ProviderID: '',
				CusCode: '',
				ProviderName: '',
				CusName: '',
				PageIndex: 1,
				pageSize: 10,
				total: 0,
				totalHP: 0,
				pageSizeHP: 10,
				pageIndexHP: 1,
				IsUploadFile: 0,
				tableDatadrjg: [],
				TableDataEditorDataOK: [], //医院选中数据
				EditorTabelData: [], //编辑授权申请弹窗表格选中数据
				PrintArr: [],
				GCYLList: [],
				GCTQList: [],
				DataListOK: [],
				FromArrHP: [],
				FromArr: [],
				FromArrEditor: [],
				headerData: [],
				tableData: [],
				headerDataEditor: [],
				tableDataEditor: [],
				headerDataEditorHP: [],
				tableDataEditorHP: [],
				StyleCss: {
					position: 'relative',
					left: -930,
					right: -62,
					opacityGCTQ: 1,
					opacityGQYL: 0
				},
				GCTQarr: [],
				GCYLarr: [],
				from: {},
				fromHP: {
					hpCode: "",
					hpName: "",
					HosType: "",
					CreateTime1: "",
					CreateTime2: "",
					authorizeStatus: "",
				},
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false, //弃审
					changeth: false, //弃审
				},
				currData: null
			}
		},
		computed: {
			userInfo() {
				return this.$store.state.MenusData;
			}
		},
		created() {
			this.businessAuthorityList()
			this.inventoryClassList()
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
			this.FromArrHP = JSON.parse(JSON.stringify(FromArrHP))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerDataEditor = JSON.parse(JSON.stringify(headerDataEditor))
			this.headerDataEditorHP = JSON.parse(JSON.stringify(headerDataEditorHP))
			if (this.userInfo && this.userInfo.IsSalesDepartment === 1) {
				this.FromArr[7].hidden = true;
			}
			this.QX()
		},
		activated() {},
		updated() {},
		methods: {
			QX() {
				let qus = []
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.CusWebMenus.map((item, index) => {
					if (item.NodeID == 77) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 80) {
								items.Nodes.map((itemes, indexes) => {
									if (itemes.NodeID == 1049) {
										qus = itemes.Buttons
									}
								})
							}
						})
					}
				})
				if (qus) {
					qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'changeth') {
							this.qx.changeth = true
						}
					})
				}
			},
			// 列表
			async businessAuthorityList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await CusRelationAuthorityList({
					CusName: this.from.CusName,
					InvClass: this.from.InvClass,
					ProviderName: this.from.ProviderName,
					IsAuthority: this.from.IsAuthority,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					TerminalHospital: this.from.TerminalHospital,
					pageSize: this.pageSize,
					pageIndex: this.PageIndex
				})
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
				loading.close();
			},
			// 授权经销商(AutoComplete)
			async HospitalList(type, query) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.FromArrEditor[2].loading = true
				let {
					code,
					message,
					data
				} = await HospitalList({
					IsTXCus: type == "AutoCompleteList" ? '1' : '',
					hpName: query,
					// hosType: "经销商",
					hpCode: this.fromHP.hpCode,
					authorizeStatus: this.fromHP.authorizeStatus,
					HosType: this.fromHP.HosType,
					CreateTime1: this.fromHP.CreateTime1,
					CreateTime2: this.fromHP.CreateTime2,
					pageSize: this.pageSizeHP,
					pageIndex: this.pageIndexHP
				})

				if (code == 0) {
					if (type == "AutoCompleteList") {
						this.FromArrEditor[2].options = []
						data.data.map((item, index) => {
							let obj = {
								value: item.HPID,
								label: item.HPName,
							}
							this.FromArrEditor[2].options.push(obj)
						})
					}
					if (type == "DialogFromList") {
						this.totalHP = data.Count
						this.tableDataEditorHP = data.data
					}
				} else {
					this.$message.warning(message)
				}
				this.FromArrEditor[2].loading = false
				loading.close()
			},
			//新增/编辑
			async dialogOKAuthorizationsAPP() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				if (this.currData) {
					let {
						code,
						message,
						data
					} = await EditCusRelationAuthority({
						ID: this.currData.ID,
						InvClass: this.FromArrEditor[0].modelvalue,
						CusCode: this.FromArrEditor[1].modelvalue,
						ProviderID: this.FromArrEditor[2].modelvalue,
						Remark: this.FromArrEditor[3].modelvalue
					})
					if (code == 0) {
						this.$message.success(message)
						this.dialogVisibAuthorizationsAPP = false
						this.businessAuthorityList()
					} else {
						this.$message.warning(message)
					}
					loading.close()
				} else {
					let {
						code,
						message,
						data
					} = await AddCusRelationAuthority({
						InvClass: this.FromArrEditor[0].modelvalue,
						CusCode: this.FromArrEditor[1].modelvalue,
						ProviderID: this.FromArrEditor[2].modelvalue,
						Remark: this.FromArrEditor[3].modelvalue
					})
					if (code == 0) {
						this.currData = null;
						this.$message.success(message)
						this.dialogVisibAuthorizationsAPP = false
						this.businessAuthorityList()
					} else {
						this.$message.warning(message)
					}
					loading.close()
				}
			},
			//编辑查看详情
			async update() {
				if (!this.currData) {
					this.$message.error('请选择操作的数据！')
					return
				}
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await InfoCusRelationAuthority({
					ID: this.currData.ID,
				})
				if (code == 0) {
					this.FromArrEditor[0].modelvalue = data.InvClass;
					this.FromArrEditor[1].modelvalue = data.CusCode;
					this.FromArrEditor[2].modelvalue = data.ProviderID;
					this.FromArrEditor[3].modelvalue = data.Remark;
					this.FromArrEditor[1].options = [{
						value: data.CusCode,
						label: data.CusName,
					}]
					this.FromArrEditor[2].options = [{
						value: data.ProviderID,
						label: data.ProviderName,
					}]
					this.dialogVisibAuthorizationsAPP = true
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
				loading.close();
			},
			// AutoComplete事件
			remoteMethod(val, par) {
				console.log(val, par, 'methodName');
				if (val.parsign == 'AuthorizedDealer') {
					this.HospitalList('AutoCompleteList', val.qurey)
				} else if (val.parsign == 'OrderingDealer') {
					this.CustomerList(val.qurey)
				}
			},
			// 授权申请弹窗，公司下拉的change事件
			invClassChange(e) {
				this.UserInfoByInvClass(e.FromArr[0].modelvalue)
			},
			addClickRow() {
				this.HospitalList('DialogFromList')
				this.GetHospitalType()
			},
			delClickRow() {
				// this.EditorTabelData //准备删除操作数据
				// tableDataEditor
				this.EditorTabelData.map((item, index) => {
					this.tableDataEditor.map((items, indexs) => {
						console.log(item.HPID == items.HPID);
						if (item.HPID == items.HPID) {
							this.tableDataEditor.splice(indexs, 1)
						}
					})
				})
			},
			handleSelectionChangeEditor(val) {
				this.EditorTabelData = val
			},
			// 订货经销商(AutoComplete)
			async CustomerList(query) {
				this.FromArrEditor[1].loading = true
				let {
					code,
					message,
					data
				} = await CustomerList({
					CusName: query,
				})
				if (code == 0) {
					this.FromArrEditor[1].options = []
					data.data.map((item, index) => {
						let obj = {
							value: item.CusCode,
							label: item.CusName,
						}
						this.FromArrEditor[1].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
				this.FromArrEditor[1].loading = false
			},
			// 授权产品下拉数据
			async UserInfoByInvClass(InvClass) {
				let {
					code,
					message,
					data
				} = await UserInfoByInvClass({
					InvClass: InvClass
				})
				if (code == 0) {
					this.FromArrEditor[3].options = []
					data.map((item, index) => {
						let obj = {
							key: item,
							value: item
						}
						this.FromArrEditor[3].options.push(obj)
					})
				}
			},
			// 客服分类
			async GetHospitalType() {
				let {
					code,
					data
				} = await GetHospitalType({

				})
				if (code == 0) {
					this.FromArrHP[3].options = []
					data.map((item, index) => {
						let obj = {
							key: index,
							value: item.Name
						}
						this.FromArrHP[3].options.push(obj)
					})
				}
			},
			handleSelectionChangeEditorHP(val) {
				this.TableDataEditorDataOK = val
			},
			reset() {
				this.FromArr.map((item, index) => {
					if (index == 6) {
						item.StartTime = '';
						item.EndTime = '';
					}
					item.modelvalue = ''
				})
				this.businessAuthorityList()
			},
			selectHP() {
				this.pageIndexHP = 1
				this.fromHP.hpCode = this.FromArrHP[0].modelvalue
				this.fromHP.hpName = this.FromArrHP[1].modelvalue
				this.fromHP.authorizeStatus = this.FromArrHP[2].modelvalue
				this.fromHP.HosType = this.FromArrHP[3].modelvalue
				this.fromHP.CreateTime1 = this.FromArrHP[4].StartTime
				this.fromHP.CreateTime2 = this.FromArrHP[4].EndTime
				this.HospitalList("DialogFromList", this.fromHP.hpName)
			},
			resetHP() {
				this.FromArrHP.map((item, index) => {
					if (index == 4) {
						item.StartTime = ''
						item.EndTime = ''
					}
					if (index != 3) {
						item.modelvalue = ''
					}
				})
			},
			handleCurrentChangeHP(PageIndex) {
				this.pageIndexHP = PageIndex
				this.HospitalList('DialogFromList')
			},
			handleSizeChangeHP(PageSize) {
				this.pageSizeHP = PageSize
				this.HospitalList('DialogFromList')
			},
			// 导出
			async ExportAuthoriy() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportCusRelationAuthority({
					CusName: this.from.CusName,
					InvClass: this.from.InvClass,
					ProviderName: this.from.ProviderName,
					IsAuthority: this.from.IsAuthority,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					TerminalHospital: this.from.TerminalHospital,
					pageSize: this.pageSize,
					pageIndex: this.PageIndex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `授权书关系导出${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
				loading.close()
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr[4].options = []
					this.FromArrEditor[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArrEditor[0].options.push(obj)
						this.FromArr[4].options.push(obj)
					})
				}
			},
			// 文件导入
			async SealUpload(file) {
				const loading = this.$loading({
					lock: true,
					text: '上传中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formData = new FormData()
				formData.append("file", file[0]);
				let res = await ImportCusRelationAuthority(formData)
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: res.message
					})
					this.businessAuthorityList()
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = res.data
					this.title = '导入结果'
					this.$message({
						type: 'error',
						message: res.message
					})
				}
				loading.close();
			},
			// 下载模板
			async DownloadTemplate() {
				let {
					data,
					code,
					message
				} = await TempletCusRelationAuthority({})
				if (code == 0) {
					window.open(data);
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 审核
			AuthorityVerify() {
				if (this.DataListOK.length == 0) {
					this.$message.warning('请选择需要审核的数据（多选）');
					return
				}
				this.dialogVisibleVerify = true;
			},
			cancelVerify() {
				this.dialogVisibleVerify = false;
			},
			dialogOKVerify() {
				let BAMIDS = [];
				this.DataListOK.forEach((item, index) => {
					BAMIDS.push(item.BAMID);
				})

			},
			Rejectapproval() {
				if (this.DataListOK.length == 0) {
					this.$message.warning('请选择需要驳回的数据（多选）');
					return
				}
				this.dialogVisibRejectReason = true
			},
			AuthorityDel() {
				if (this.DataListOK.length == 0) {
					this.$message.warning('请选择需要删除的数据（多选）');
					return
				}
				this.dialogVisibleDel = true
			},
			AuthorityInvalid() {
				if (this.DataListOK.length == 0) {
					this.$message.warning('请选择需要作废的数据（多选）');
					return
				}
				this.dialogVisibleInv = true
			},
			cancelInv() {
				this.dialogVisibleInv = false
			},
			//删除
			async dialogOKDel() {
				let {
					code,
					data,
					message
				} = await DeleteCusRelationAuthority({
					IDs: this.DataListOK.map(item => item.ID)
				})
				if (code == 0) {
					this.$message.success(message);
					this.businessAuthorityList();
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
					this.dialogVisibdelReason = false
				} else {
					this.dialogVisiblesdrjg = true;
					this.tableDatadrjg = data;
					this.title = '删除结果';
					this.$message.warning(message);
				}
				this.dialogVisibleDel = false;
			},
			dialogOKInv() {
				let BAMIDS = [];
				this.DataListOK.forEach((item, index) => {
					BAMIDS.push(item.BAMID);
				})
				this.BusinessAuthorityDisable(BAMIDS)
			},
			cancelCancelSeal() {
				this.dialogVisibleCancelSeal = false
			},
			dialogOKCancelSeal() {
				this.BusinessAuthorityRemoveAttachment()
			},
			handleDrop(e) {
				switch (e) {
					case 'a':
						this.PrintAll();
						break;
					case 'b':
						this.DownloadAll();
						break;
				}
			},
			rightClick() {
				this.$nextTick(() => {
					this.StyleCss.right = -62;
					this.StyleCss.left = -1000;
					this.StyleCss.opacityGCTQ = 1;
					this.StyleCss.opacityGQYL = 0;
				})
				this.GCTQORGCYL = true;
			},
			leftClick() {
				this.$nextTick(() => {
					this.StyleCss.left = 0;
					this.StyleCss.right = -1000;
					this.StyleCss.opacityGCTQ = 0;
					this.StyleCss.opacityGQYL = 1;
				})
				this.GCTQORGCYL = false;
			},
			// 归创通桥下载
			GCTQdownload(GCTQDATA) {
				this.Download(GCTQDATA)
			},
			// 归创通桥打印
			GCTQPrint(GCTQDATA) {
				this.PrintClick(GCTQDATA)
			},
			//归创医疗下载
			GCYLdownload(GCYLDATA) {
				this.Download(GCYLDATA)
			},
			// 归创医疗打印
			GCYLPrint(GCYLDATA) {
				this.PrintClick(GCYLDATA)
			},
			select() {
				this.pageIndex = 1
				this.from.ProviderName = this.FromArr[0].modelvalue
				this.from.CusName = this.FromArr[1].modelvalue
				this.from.IsAuthority = this.FromArr[2].modelvalue
				this.from.CreateTime1 = this.FromArr[3].StartTime
				this.from.CreateTime2 = this.FromArr[3].EndTime
				this.from.InvClass = this.FromArr[4].modelvalue
				this.from.TerminalHospital = this.FromArr[5].modelvalue
				this.businessAuthorityList()
			},
			reset() {
				this.FromArr.map((item, index) => {
					if (index == 3 || index == 4) {
						item.StartTime = '';
						item.EndTime = '';
					}
					item.modelvalue = ''
				})
			},
			handleSelectionChange(val) {
				this.DataListOK = val
			},
			onRowClick(val) {
				this.currData = val;
				console.log(this.currData);
			},
			handleCurrentChange(PageIndex) {
				this.PageIndex = PageIndex
				this.businessAuthorityList()
			},
			handleSizeChange(PageSize) {
				this.pageSize = PageSize
				this.businessAuthorityList()
			},
			cancelRejectReason() {
				this.dialogVisibRejectReason = false
			},
			dialogOKRejectReason() {
				let BAMIDS = [];
				this.DataListOK.forEach((item, index) => {
					BAMIDS.push(item.BAMID);
				})
				this.BusinessAuthorityReject(BAMIDS)

			},
			canceldelReason() {
				this.dialogVisibdelReason = false
			},
			dialogOKdelReason() {
				let BAMIDS = [];
				this.DataListOK.forEach((item, index) => {
					BAMIDS.push(item.BAMID);
				})
				console.log(this.RejectReason, 'this.RejectReason');
				this.BusinessAuthorityDelete(BAMIDS)

			},
			add() {
				this.dialogVisibAuthorizationsAPP = true;
			}
		}
	}
</script>
<style scoped lang='less'>
	.GCTQ {
		// border: 1px solid red;
		transition: all 0.5s;
	}

	.GCYL {
		//  border: 1px solid rgb(23, 120, 211);
		transition: all 0.5s;
	}

	.Authority {
		width: 100%;
		height: 100%;

		.TopSearch {
			margin: 1px 10px;
			width: 938px;
			height: 164px;
			// outline: 1px solid red;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}

		.BottomTable {
			margin: 32px 10px;
			padding: 10px;
			width: 920px;
			// height: 518px;
			// border: 1px solid #e5e7ea;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}
	}


	.drop-down-link {
		margin: 10px;
		width: 100%;
		height: 32px;
		line-height: 32px;
		color: rgb(0, 0, 0);
		font-size: 14px;
		background-color: rgb(249, 250, 252);
		border: 1px solid #e6e6e6;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}

	/deep/.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		background-color: rgb(255 235 235);
		color: #606266;
	}
</style>